import EmailStatus from "@mapmycustomers/shared/enum/EmailStatus";
import Email from "@mapmycustomers/shared/types/email/Email";
import { Activity } from "@mapmycustomers/shared/types/entity";

export interface EmailRecipientStatus {
  email?: string;
  entityId?: Email["entityId"];
  hasBounced: boolean;
  id: Email["id"];
  name: string;
  status: EmailStatus;
}

// Derives the per-recipient delivery status for a multi-contact email activity
// from its `emailLogs[]` (detail-read only). Driven by the logs rather than
// `contacts[]` so bounced recipients delinked from `contactId[]` still appear.
// Every log is kept (this is an audit surface — dropping rows would mis-state the
// recipient count); each carries the log `id` for a stable React key. `name` may
// be "" if a log has no name and no email — the consumer renders a fallback.
const getActivityEmailRecipients = (activity: Activity): EmailRecipientStatus[] =>
  (activity.emailLogs ?? []).map((log) => {
    const recipient = log.recipientAddress?.[0];
    return {
      id: log.id,
      email: recipient?.email,
      entityId: log.entityId,
      hasBounced: Boolean(log.hasBounced),
      name: recipient?.name || recipient?.email || "",
      status: log.status,
    };
  });

export default getActivityEmailRecipients;
